import HeroSearchForm2Mobile from "./HeroSearchForm2Mobile";

const HeroSearchForm2MobileFactory = () => {
  return <HeroSearchForm2Mobile />;
};

export default HeroSearchForm2MobileFactory;
